/* SETTINGS */
export const CHANGE_LOCALE = 'CHANGE_LOCALE'

/* AUTH */
export const LOGIN_USER = 'LOGIN_USER'
export const SET_USER = 'SET_USER'
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS'
export const REGISTER_USER = 'REGISTER_USER'
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS'
export const LOGOUT_USER = 'LOGOUT_USER'

/* MENU */
export const MENU_SET_CLASSNAMES = 'MENU_SET_CLASSNAMES'
export const MENU_CONTAINER_ADD_CLASSNAME = 'MENU_CONTAINER_ADD_CLASSNAME'
export const MENU_CLICK_MOBILE_MENU = 'MENU_CLICK_MOBILE_MENU'
export const MENU_CHANGE_DEFAULT_CLASSES = 'MENU_CHANGE_DEFAULT_CLASSES'
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS = 'MENU_CHANGE_HAS_SUB_ITEM_STATUS'
export const SET_BUTTON_LOADING = 'SET_BUTTON_LOADING'
export const SET_REQUESTING = 'SET_REQUESTING'

/* CARDS */
export const SET_CARD_DEFAULT = 'SET_CARD_DEFAULT'
export const SET_CARD_TYPING = 'SET_CARD_TYPING'
export const SET_CARD_TYPING_FOCUSED_FIELD = 'SET_CARD_TYPING_FOCUSED_FIELD'
export const SET_CARD_SHOW = 'SET_CARD_SHOW'
export const CLEAN_CARD_DEFAULT = 'CLEAN_CARD_DEFAULT'
export const CLEAN_CARD_TYPING = 'CLEAN_CARD_TYPING'
export const CLEAN_CARD_SHOW = 'CLEAN_CARD_SHOW'
export const SET_IS_TYPING_CARD = 'SET_IS_TYPING_CARD'
export const SET_IS_SHOWING_CARD = 'SET_IS_SHOWING_CARD'
export const SHOW_CARD = 'SHOW_CARD'
export const SET_CARD_LIST = 'SET_CARD_LIST'
export const ADD_CARD_TO_CARD_LIST = 'ADD_CARD_TO_CARD_LIST'
export const REMOVE_CARD_FROM_CARD_LIST = 'REMOVE_CARD_FROM_CARD_LIST'
export const SET_PREFERRED_CARD = 'SET_PREFERRED_CARD'

/* TEXTS */
export const SET_SYNONYMOUS_TEXT = 'SET_SYNONYMOUS_TEXT'
export const ADD_SYNONYMOUS_TEXT = 'ADD_SYNONYMOUS_TEXT'
export const REMOVE_SYNONYMOUS_TEXT = 'REMOVE_SYNONYMOUS_TEXT'
export const UPDATE_SYNONYMOUS_TEXT = 'UPDATE_SYNONYMOUS_TEXT'
export const SHOW_SYNONYMOUS_TEXT = 'SHOW_SYNONYMOUS_TEXT'
export const LIST_SYNONYMOUS_TEXTS = 'LIST_SYNONYMOUS_TEXTS'

export const SET_PARAPHRASE_TEXT = 'SET_PARAPHRASE_TEXT'
export const ADD_PARAPHRASE_TEXT = 'ADD_PARAPHRASE_TEXT'
export const REMOVE_PARAPHRASE_TEXT = 'REMOVE_PARAPHRASE_TEXT'
export const UPDATE_PARAPHRASE_TEXT = 'UPDATE_PARAPHRASE_TEXT'
export const SHOW_PARAPHRASE_TEXT = 'SHOW_PARAPHRASE_TEXT'
export const LIST_PARAPHRASE_TEXTS = 'LIST_PARAPHRASE_TEXTS'

export const ADD_SPINTAX_TEXT = 'ADD_SPINTAX_TEXT'
export const REMOVE_SPINTAX_TEXT = 'REMOVE_SPINTAX_TEXT'
export const UPDATE_SPINTAX_TEXT = 'UPDATE_SPINTAX_TEXT'
export const SHOW_SPINTAX_TEXT = 'SHOW_SPINTAX_TEXT'
export const LIST_SPINTAX_TEXTS = 'LIST_SPINTAX_TEXTS'

export * from './menu/actions'
export * from './settings/actions'
export * from './auth/actions'
export * from './card/actions'
export * from './text/actions'
